module.exports = __webpack_public_path__ + "static/img/1363_phase_function_Paper_PointsHejduk_Prediction.6bce0e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1363_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gcIZ
// module chunks = 0